let store = require("../store");
let actions = require("../actions");

let FormControls = mc.widgets.FormControls;
let FormFeedback = mc.widgets.FormFeedback;
let FormRange = mc.widgets.FormRange;

class SubjectFormView extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();
  }

  getInitialState() {
    let { studyId, subject } = this.props;
    let study = store.getState().study[studyId];

    return {
      subject: mc.utils.clone(subject) || {
        displayName: "",
        timezone: "",
        studyId,
        metadataFields: []
      },
      errors: [],
      submitting: false,
      study
    };
  }

  componentDidMount() {
    this.unsubscribe = store.subscribe(this.handleStoreChange.bind(this));

    actions.loadStudy(this.props.studyId);
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  handleStoreChange() {
    let study = store.getState().study[this.props.studyId];

    this.setState({ study });
  }

  mutate(fieldName, fieldValue) {
    let subject = mc.utils.clone(this.state.subject);
    subject[fieldName] = fieldValue;

    this.setState({ subject });
  }

  setDisplayName(evt) {
    this.mutate("displayName", evt.target.value);
  }

  setGender(evt) {
    this.mutate("gender", evt.target.value || "");
  }

  setAge(evt) {
    this.mutate("age", evt.target.value || null);
  }

  setWeight(evt) {
    this.mutate("weight", evt.target.value * mc.math.KILOS_PER_POUND);
  }

  setHeight(n) {
    this.mutate("height", n * mc.math.METERS_PER_INCH || "");
  }

  setTimezone(evt) {
    this.mutate("timezone", evt.target.value || "");
  }

  setCustomField(displayName, evt) {
    let fields = this.state.subject.metadataFields;
    let index = fields.findIndex((f) => f.displayName === displayName);
    let value = evt.target.value;

    if (index > -1) {
      if (value.length) {
        fields[index].value = value;
      }
      else {
        fields.splice(index, 1);
      }
    }
    else {
      fields.push({ displayName, value });
    }

    this.mutate("metadataFields", fields);
  }

  checkAge(evt) {
    let age = parseInt(evt.target.value);

    if (!isNaN(age) && age < 18) {
      this.mutate("age", 18);
    }
  }

  cancel() {
    this.props.onCancel();
  }

  validate(subject) {
    return subject.displayName.trim().length > 0 && subject.timezone !== "";
  }

  saveSubject() {
    let { subject } = this.state;
    let method = subject.id ? "UPDATE" : "CREATE";

    actions.saveSubject(subject, method).then((function (payload) {
      if (payload.errors.length) {
        this.setState({
          errors: payload.errors,
          submitting: false
        });
      }
      else {
        this.props.onSave(payload.subject);
      }
    }).bind(this));

    this.setState({
      submitting: true
    });
  }

  deleteSubject() {
    let subject = this.state.subject;
    let devices = subject.devices.filter((device) => device.states[0].value !== "UNAPPLIED");

    if (devices.length) {
      mc.ui.alert(tx("error.delete_subject"));
      return;
    }

    mc.ui.alert(tx("delete_subject"), {
      level: "warn",
      mode: "confirm",
      labels: {
        confirm: tx("deactivate"),
        cancel: tx("cancel")
      },
      onHide: (function (confirmed) {
        if (confirmed) {
          actions.saveSubject(subject, "DELETE").then((function (payload) {
            if (payload.errors.length) {
              this.setState({
                errors: payload.errors,
                submitting: false
              });
            }
            else {
              this.props.onDelete();
            }
          }).bind(this));

          this.setState({
            submitting: true
          });
        }
      }).bind(this)
    });
  }

  render() {
    let {
      subject,
      study = {}
    } = this.state;

    if (!subject) {
      return null;
    }

    return (
      <div className="rc-subject-form-view">
        <table className="mc-form">
          <tbody>
            <tr>
              <th>{tx("subject_id") + "*"}</th>
              <td>
                <input
                  name="displayName"
                  type="text"
                  maxLength="32"
                  value={subject.displayName}
                  onChange={this.setDisplayName.bind(this)}/>
              </td>
            </tr>
            {(study.lifecycleState !== "INITIALIZED") && !!subject.id ? null : (
              <tr>
                <th>{tx("timezone") + "*"}</th>
                <td>
                  <select name="timezone" onChange={this.setTimezone.bind(this)} value={subject.timezone}>
                    <option/>
                    {
                        Array.from(mc.format.timezonesByRegion(), ([group, tzones]) =>
                            (
                             <optgroup label={group}>
                                { tzones.map((tz) =>
                                    (<option key={tz} value={tz}>{tz}</option>)
                                )}
                             </optgroup>
                            )
                        )
                    }
                  </select>
                </td>
              </tr>
            )}
            <tr>
              <th>{tx("gender")}</th>
              <td>
                <select name="gender" onChange={this.setGender.bind(this)} value={subject.gender || ""}>
                  <option/>
                  <option value="MALE">{tx("gender.MALE")}</option>
                  <option value="FEMALE">{tx("gender.FEMALE")}</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>{tx("age")}</th>
              <td>
                <input
                  name="age"
                  type="number"
                  min="18"
                  max="100"
                  step="1"
                  value={subject.age || ""}
                  onChange={this.setAge.bind(this)}
                  onBlur={this.checkAge.bind(this)}/>
                  <small>{"(18+)"}</small>
              </td>
            </tr>
            <tr>
              <th>{tx("weight")}</th>
              <td>
                <input
                  name="weight"
                  type="number"
                  min="0"
                  max="500"
                  step="1"
                  value={subject.weight ? Math.round(subject.weight * mc.math.POUNDS_PER_KILO) : ""}
                  onChange={this.setWeight.bind(this)}/>
                  {"lbs."}
              </td>
            </tr>
            <tr>
              <th>{tx("height")}</th>
              <td>
                <FormRange
                  name="height"
                  nullable={true}
                  min={48}
                  max={84}
                  value={subject.height ? Math.round(subject.height * mc.math.INCHES_PER_METER) : ""}
                  tx={(n) => `${Math.floor(n / 12)}’ ${n % 12}”`}
                  onChange={this.setHeight.bind(this)}/>
              </td>
            </tr>
            {
              (study.subjectMetadataFields || []).map((function (field) {
                let input;
                let callback = this.setCustomField.bind(this, field.displayName);
                let found = subject.metadataFields.find(function (f) {
                  return f.displayName === field.displayName;
                });
                let value = found ? found.value : "";

                switch (field.type) {
                  case "FREETEXT":
                    input = <textarea rows={2} cols={20} maxLength="128" onChange={callback} value={value}/>;
                    break;
                  case "NUMERIC":
                    input = <input type="number" onChange={callback} value={value}/>;
                    break;
                  case "MULTIPLECHOICE":
                    input = (
                      <select onChange={callback} value={value}>
                        <option/>
                        {field.values.map(function (opt) {
                          return <option key={opt}>{opt}</option>;
                        })}
                      </select>
                    );
                    break;
                  case "BOOLEAN":
                    input = (
                      <select onChange={callback} value={value}>
                        <option/>
                        <option value="YES">{tx("answer.YES")}</option>
                        <option value="NO">{tx("answer.NO")}</option>
                      </select>
                    );
                    break;
                }

                return (
                  <tr key={field.displayName}>
                    <th>{field.displayName}</th>
                    <td>{input}</td>
                  </tr>
                );
              }).bind(this))
            }
          </tbody>
        </table>
        <FormFeedback errors={this.state.errors}/>
        <FormControls
          onSave={this.saveSubject.bind(this)}
          onCancel={this.cancel.bind(this)}
          onDelete={subject.id && this.deleteSubject.bind(this)}
          labels={{ "delete": tx("deactivate") }}
          enabled={!this.state.submitting && this.validate(subject)}/>
      </div>
    );
  }
}

module.exports = SubjectFormView;
